//custom js
(function () {
  gsap.registerPlugin(ScrollTrigger);
  // apply parallax effect to any element with a data-speed attribute
  gsap.utils.toArray("[data-speed]").forEach(el => {
    gsap.to(el, {
      y: function() {return (1 - parseFloat(el.getAttribute("data-speed"))) * (ScrollTrigger.maxScroll(window) - (this.scrollTrigger ? this.scrollTrigger.start : 0))},
      ease: "back.out(3)",
      scrollTrigger: {
        trigger: el,
        start: "top 100%",
        end: "max",
        invalidateOnRefresh: true,
        scrub: true,
        // markers: true
      }
    });
  });
})();

class ApplicationSection4 extends HTMLElement {
  constructor() {
    super();
        this.$ = function(slt) { return this.querySelectorAll(slt); }
        this.times = 0;
        this.Tween = {};
        this.create = {};
        this.setUp();
    }
    setUp(){
        this.create.dom = {};
        this.create.dom.img = this.$(".wrap__image--block");
        this.create.dom.arrow = this.$(".wrap__image--arrow");

        gsap.registerPlugin(ScrollTrigger);
        this.Tween = gsap.timeline();
        ScrollTrigger.create({
            trigger: this,
            animation: this.Tween, 
            start: "top 60%",
            end: "top 20%",
            scrub: 1,
            // markers: true
        });
        this.addEvent();
    }
    addEvent(){
        this.animationScroll();
    }
    animationScroll(){
        this.times += 0;
        this.Tween.from(this.create.dom.img[1],{ y: 300, autoAlpha: 0}, { y: 0, autoAlpha: 1, ease: "none", duration: 0.5} , this.times);
        this.Tween.to(this.create.dom.arrow,{ autoAlpha: 1, ease: "none", duration: 0.5} , this.times);
    }
}
  customElements.define('application-section4', ApplicationSection4);
class PedagogicalPillar extends HTMLElement {
  constructor() {
      super();
      this.$ = function(slt) { return this.querySelectorAll(slt);}
      this.times = 0;
      this.Tween = {};
      this.create = {};
      this.setUp();
  }
  setUp(){
      this.create.dom = {};
      this.create.dom.imgBg = this.$(".wrap__img--bg");
      this.create.dom.imgDt = this.$(".wrap__img--bgdt");
      this.create.dom.imgMb = this.$(".wrap__img--bgmb");
      this.create.dom.icon = this.$(".pedagogical__pillar--image-icon");
    
      new gsap.registerPlugin(ScrollTrigger);
      this.Tween = new gsap.timeline();
      ScrollTrigger.create({
          trigger: this,
          animation: this.Tween,
          start: "top center",
          end: "top 10%", 
          scrub: 1,
          // markers: true
      });
      this.addEvent();
  }
  addEvent(){
      this.animationScroll();
  }
  animationScroll(){
    this.times += 0;
    this.Tween.to(this.create.dom.imgBg, { x: 0, autoAlpha: 1, duration: 1, ease: "none" }, this.times);
    this.times = 1;
    this.Tween.to([this.create.dom.imgDt,this.create.dom.imgMb ], { x: 0, autoAlpha: 1, duration: 1, ease: "none" }, this.times);
    this.Tween.to(this.create.dom.icon, { x: 0, autoAlpha: 1, duration: 1, ease: "none" }, this.times);
    this.times = 0;
  }
}
customElements.define("pedagogical-pillar", PedagogicalPillar);
class ProductsInfo extends HTMLElement {
  constructor() {
      super();
      this.$ = function(slt) { return this.querySelectorAll(slt);}
      this.times = 0;
      this.Tween = {};
      this.create = {};
      this.setUp();
  }
  setUp(){
      this.create.dom = {};
      this.create.dom.icons = this.$(".col-media__image-icon .type-image_icon");
      this.create.dom.imageTag = this.$(".product-info__image.type-image_tag");
      this.create.dom.arrow = this.$(".product-info__image-text svg");
      this.create.dom.textImage = this.$(".product-info__image-text span");
      this.create.dom.imgBig = this.$(".js-imgbig-animation");
      this.create.dom.textIcon = this.$(".product-info__text-icon");
      new gsap.registerPlugin(ScrollTrigger);
      this.Tween = new gsap.timeline();
      ScrollTrigger.create({
          trigger: this,
          animation: this.Tween,
          start: "top center",
          end: "top 20%", 
          scrub: 1,
          // markers: true
      });
      this.addEvent();
  }
  addEvent(){
      //add event listener
      this.animationScroll();
  }
  animationScroll(){
      this.times += 0;
      // for(let item of this.create.dom.icons){
      //     this.Tween.to(item, { y: 0, autoAlpha:1, duration: 1, ease: "none"},this.times);
      //     this.times += 1;
      // }
      // this.Tween.from(this.create.dom.imgBig[1],{y: 150, autoAlpha: 0 }, { y: 0, autoAlpha:1, duration: 1, ease: "none"},this.times);
      this.times += 1;
      this.Tween.to(this.create.dom.arrow, { autoAlpha:1, duration: 1, ease: "none"},this.times);
      // this.Tween.to(this.create.dom.imageTag, { y: 0, autoAlpha:1, duration: 1, ease: "none"},this.times);
      this.times += 1;
      this.Tween.to(this.create.dom.textImage, { y: 0, autoAlpha: 1, duration: 1, ease: "none" }, this.times);
      for (let i = 0; i < this.create.dom.textIcon.length; i++){
        this.Tween.to(this.create.dom.textIcon[i], { x: 0, autoAlpha: 1, duration: 1, ease: "none" }, this.times);
        this.times += 1;
      }
      this.times = 0;
  }
}
customElements.define("products-info", ProductsInfo);
class ComponentTabInfo extends HTMLElement {
    constructor() {
        super();
        this.setUp();
    }
    setUp(){
        this.Tabs = this.querySelectorAll('.tab-info__tab-wrapper .tab');
        this.Panels = this.querySelectorAll('.tab-info__content-wrapper .tab-info__tab-content');
        this.active = this.querySelector('.tab-info__tab-wrapper .div-active');
        this.active.style.width = this.Tabs[0].offsetWidth + 'px';
        this.active.style.height = this.Tabs[0].offsetHeight + 'px';
        this.active.style.transform = 'translateX(' + this.Tabs[0].offsetLeft + 'px)';
        this.addEvent();
    }
    addEvent(){
        this.Tabs.forEach(tab => tab.addEventListener('click', this.toggleClick.bind(this)));
    }
    toggleClick(event) {
        this.Tabs.forEach(tab => tab.classList.remove('active'));
        let id = event.target.dataset.tab;
        [...this.Panels].filter(panel => {
            if (panel.dataset.tab == id) {
                panel.classList.add('active');
            } else {
                panel.classList.remove('active');
            }
        })
        event.target.classList.add('active');
        this.active.style.transform = 'translateX(' + event.target.offsetLeft + 'px)';
        this.active.style.width = event.target.offsetWidth + 'px';
        this.active.style.height = event.target.offsetHeight + 'px';
        this.active.style.color = "#ffffff";
    }
}
customElements.define('component-tab-info', ComponentTabInfo);
class MediasContent extends HTMLElement {
    constructor() {
        super();
        this.$ = function(slt) { return this.querySelectorAll(slt);}
        this.times = 0;
        this.Tween = {};
        this.create = {};
        this.setUp();
    }
    setUp(){
        this.create.dom = {};
        this.create.dom.items = this.$(".box__text-icon.style--small");
        this.create.dom.boxTexts = this.$(".media-content__image-text.box__image-text span");
        gsap.registerPlugin(ScrollTrigger);
        this.Tween = gsap.timeline();
        ScrollTrigger.create({
            trigger: this,
            animation: this.Tween,
            start: "top 40%",
            end: "center 40%", 
            scrub: 1,
            // markers: true
        });
        this.addEvent();
    }
    addEvent(){
        //add event listener
        this.animationScroll();
    }
    animationScroll(){
        this.times += 0;
        this.Tween.to(".media-content__image-img img", { y: 0, duration: 2, ease: "none"},this.times);
        for( let boxText of this.create.dom.boxTexts){
            let times = 0;
            this.Tween.add(this.Tween.to(boxText, { autoAlpha: 1, duration: 1, ease: "none"}), times);
            times += 1;
        }
        for( let item of this.create.dom.items){
            let times = 0;
            this.Tween.add(this.Tween.to(item, { autoAlpha: 1, duration: 1, ease: "none"}), this.times);
            times += 1;
        }
        this.times += 0;
    }
}
customElements.define("medias-content", MediasContent);



function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );


  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
    if (this.dataset.priceChange) {
      this.input.setAttribute("data-price_total", this.input.value * this.input.getAttribute("data-price"));
      const elmPrice = document.querySelectorAll('.product-form__total .price__regular .price-item--regular');
      elmPrice[0].innerHTML = Shopify.formatMoney(this.input.getAttribute('data-price_total'),Shopify.money_format)
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

const isIOSChrome = /CriOS/.test(navigator.userAgent) && /iP(ad|hone|od)/.test(navigator.userAgent);
const setViewportVars = () => {
  const visualViewport = window.visualViewport;
  const viewportHeight = isIOSChrome
    ? (visualViewport && visualViewport.height) || document.documentElement.clientHeight || window.innerHeight
    : window.innerHeight;
  const chromeUiHeight = isIOSChrome
    ? Math.max(0, window.innerHeight - viewportHeight)
    : 0;

  document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);
  document.documentElement.style.setProperty('--chrome-ui-height', `${chromeUiHeight}px`);
};

if (isIOSChrome) {
  document.documentElement.classList.add('is-ios-chrome');
  setViewportVars();
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setViewportVars);
    window.visualViewport.addEventListener('scroll', setViewportVars);
  }
  window.addEventListener('resize', setViewportVars);

  const syncCartDrawerHeight = () => {
    const cartDrawer = document.querySelector('.header__subNav.header__subNav--cart');
    if (!cartDrawer) return;
    cartDrawer.style.height = 'var(--viewport-height, 100vh)';
    cartDrawer.style.maxHeight = 'var(--viewport-height, 100vh)';
  };

  const tick = () => {
    setViewportVars();
    syncCartDrawerHeight();
    window.requestAnimationFrame(tick);
  };

  window.requestAnimationFrame(tick);
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.btnCloseMenu = document.querySelector('.btn-close-menumb');

    this.btnCloseMenu.addEventListener('click', this.onCloseButtonClick.bind(this));
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        document.body.style.overflow = "hidden";
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('menu-drawer-open');

  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('menu-drawer-open');

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    console.log('globaljs close')
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);

  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// COUNT DOWN -----------------------------------------------
// assets/countdown-placeholder.js
//@@@ 🏴‍☠️ One Piece débarque dans !!!2026-09-27 18:00:00.000!!! préparez-vous// La promo est déjà finie@@@
document.addEventListener('DOMContentLoaded', () => {
  const PLACEHOLDER_REGEX = /@@@\s*(.*?)!!!(.+?)!!!(.*?)\/\/(.*?)@@@/g;
  /**
   * Parcourt tous les nœuds texte du DOM et remplace les placeholders.
   */
  function replaceCountdownPlaceholders() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    const textNodes = [];
    let currentNode;
    while ((currentNode = walker.nextNode())) {
      if (currentNode.nodeValue && PLACEHOLDER_REGEX.test(currentNode.nodeValue)) {
        textNodes.push(currentNode);
      }
      // Réinitialiser lastIndex pour permettre plusieurs tests sur d'autres nœuds
      PLACEHOLDER_REGEX.lastIndex = 0;
    }
    textNodes.forEach(processTextNode);
  }
  /**
   * Traite un nœud texte contenant au moins un placeholder.
   */
  function processTextNode(textNode) {
    const originalText = textNode.nodeValue;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;
    while ((match = PLACEHOLDER_REGEX.exec(originalText)) !== null) {
      const [fullMatch, beforeText, dateString, afterText, fallbackText] = match;
      // Texte avant le placeholder
      if (match.index > lastIndex) {
        fragment.appendChild(
          document.createTextNode(originalText.slice(lastIndex, match.index))
        );
      }
      // Création du span de countdown
      const span = document.createElement('span');
      span.className = 'js-countdown-placeholder';
      span.dataset.before = beforeText.trim();     // ex: "Plus que"
      span.dataset.date = dateString.trim();       // ex: "2024-09-27 18:00:00.000"
      span.dataset.after = afterText.trim();       // ex: "avant fin de la promo"
      span.dataset.fallback = fallbackText.trim(); // ex: "La promo est déjà finie"
      span.textContent = '...'; // texte temporaire avant premier calcul
      fragment.appendChild(span);
      lastIndex = match.index + fullMatch.length;
    }
    // Texte après le dernier placeholder
    if (lastIndex < originalText.length) {
      fragment.appendChild(
        document.createTextNode(originalText.slice(lastIndex))
      );
    }
    textNode.parentNode.replaceChild(fragment, textNode);
  }
  /**
   * Formate un delta en millisecondes en "Xj Yh Zm Ts".
   */

  /**
   * Calcule les jours/heures/minutes/secondes restants à partir d'un delta en millisecondes.
   */
  function getRemainingTime(ms) {
    if (ms <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return { days, hours, minutes, seconds };
  }

  /**
   * Ajoute un bloc <span> pour une unité (j/h/m/s).
   * Exemple de structure :
   * <span class="countdown-part countdown-part--days">
   *   <span class="countdown-part__value">2</span>
   *   <span class="countdown-part__unit">j</span>
   * </span>
   */
  function appendCountdownPart(container, value, unitLabel, unitKey) {
    const part = document.createElement('span');
    part.className = `countdown-part countdown-part--${unitKey}`;

    const valueSpan = document.createElement('span');
    valueSpan.className = 'countdown-part__value';
    valueSpan.textContent = value;

    const unitSpan = document.createElement('span');
    unitSpan.className = 'countdown-part__unit';
    unitSpan.textContent = unitLabel;

    part.appendChild(valueSpan);
    part.appendChild(unitSpan);

    container.appendChild(part);
  }
  /**
   * Convertit la chaîne de date du placeholder en objet Date.
   * Exemple d'entrée: "2024-09-27 18:00:00.000"
   * On la transforme en ISO local: "2024-09-27T18:00:00.000"
   */
  function parsePlaceholderDate(dateString) {
    const normalized = dateString.trim().replace(' ', 'T');
    const d = new Date(normalized);
    if (Number.isNaN(d.getTime())) {
      return null;
    }
    return d;
  }
  /**
   * Met à jour tous les spans de countdown.
   */
  function updateCountdowns() {
    const spans = document.querySelectorAll('.js-countdown-placeholder');
    spans.forEach((span) => {
      const before = span.dataset.before || '';
      const after = span.dataset.after || '';
      const fallback = span.dataset.fallback || '';
      const dateStr = span.dataset.date;
      const deadline = parsePlaceholderDate(dateStr);
      if (!deadline) {
        // Si la date est invalide, on affiche directement le fallback
        span.textContent = fallback;
        return;
      }
      const now = new Date();
      const diff = deadline.getTime() - now.getTime();
      if (diff <= 0) {
        // Promo finie
        span.textContent = fallback;
      } else {
        const remaining = getRemainingTime(diff);

        // On reconstruit complètement le contenu du span
        span.innerHTML = '';

        // Texte "avant" (optionnel)
        if (before) {
          const beforeSpan = document.createElement('span');
          beforeSpan.className = 'countdown-before';
          beforeSpan.textContent = before.trim() + ' ';
          span.appendChild(beforeSpan);
        }

        // Conteneur principal pour les unités
        const wrapper = document.createElement('span');
        wrapper.className = 'countdown-wrapper';

        appendCountdownPart(wrapper, remaining.days, 'j', 'days');
        appendCountdownPart(wrapper, remaining.hours, 'h', 'hours');
        appendCountdownPart(wrapper, remaining.minutes, 'm', 'minutes');
        appendCountdownPart(wrapper, remaining.seconds, 's', 'seconds');

        span.appendChild(wrapper);

        // Texte "après" (optionnel)
        if (after) {
          const afterSpan = document.createElement('span');
          afterSpan.className = 'countdown-after';
          afterSpan.textContent = ' ' + after.trim();
          span.appendChild(afterSpan);
        }
      }
    });
  }
  // Initialisation
  replaceCountdownPlaceholders();
  updateCountdowns();
  // Mise à jour toutes les secondes
  setInterval(updateCountdowns, 1000);
});

// FOLLOW LAST PAGE - OPEN CART DRAWER ------------------------------------------------------

let previousURL = '';

if (sessionStorage.getItem('previousURL')) {
  previousURL = sessionStorage.getItem('previousURL');
}

if(previousURL.includes('cart') == true){
  const headerNavItemCart = document.querySelector('.cart-drawer__opener');
  headerNavItemCart.classList.add("active");
}

sessionStorage.setItem('previousURL', window.location.href);

// ------------------------------------------------------------------------------------------
